// app/javascript/controllers/dropdown_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "icon"]

  toggle(event) {
    event.stopPropagation()
    const isHidden = this.menuTarget.classList.contains("hidden")

    if (isHidden) {
      this.menuTarget.classList.remove("hidden")
      this.iconTarget.classList.add("rotate-180")
      // Fechar ao clicar fora
      document.addEventListener("click", this.closeOutside.bind(this), { once: true })
    } else {
      this.close()
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.iconTarget.classList.remove("rotate-180")
  }

  closeOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}